import { render, staticRenderFns } from "./QuickItemView.vue?vue&type=template&id=ce05e020"
import script from "./QuickItemView.vue?vue&type=script&lang=js"
export * from "./QuickItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports